//  Angular imports
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
//  Application imports
import { WINDOW_TOKEN } from 'app/window-token';
//  Third party imports
import { OidcSecurityService, OpenIdConfiguration } from 'angular-auth-oidc-client';

@Component({
    selector: 'zf-account-selected',
    template: ''
})
export class AccountSelectedComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private oidc = inject(OidcSecurityService);
    private window = inject<Window>(WINDOW_TOKEN);

    public ngOnInit(): void {
        const data = this.route.snapshot.queryParamMap.get('data');
        this.oidc.getConfiguration().subscribe((config: OpenIdConfiguration) => {
            // set our state to preserve who is logged in.
            this.oidc.setState(data, config.configId).subscribe(() => {
                this.oidc.authorize(config.configId);
            });
        });
    }
}
